import React from 'react';

import { Container, Typography } from "@mui/material";

const DogovirOfertuPage = () => {
    return (
        <Container sx={{ my: "30px" }}>
            <Typography variant="h5" className='title'>ДОГОВІР ОФЕРТИ</Typography>
            <Typography variant="h5" className='subtitle'>
                1. Загальні положення
            </Typography>
            <ul>
                <li>1.1. Справжня оферта є офіційною пропозицією інтернет-магазину SHOPERS_VI, далі за текстом –
                    «Продавець», укласти Договір купівлі-продажу товарів дистанційним способом, тобто через
                    Інтернет-магазин, далі за текстом – «Договір», і розміщує Публічну оферту (пропозицію) на офіційному
                    інтернет-сайті Продавця https://shopersvi.com.ua (далі – «Інтернет-сайт»).
                </li>
                <li>1.2. Моментом повного та безумовного прийняття Покупцем пропозиції Продавця (акцептом) укласти
                    електронний договір купівлі-продажу товарів, вважається факт оплати Покупцем замовлення на умовах
                    цього Договору, у строки та за цінами, вказаними на Інтернет-сайті Продавця.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                2. Поняття та визначення
            </Typography>
            <ul>
                <li>2.1. У справжній оферті, якщо контекст не потребує іншого, Нижченаведені терміни мають такі
                    значення:<br />
                    <br />
                    * «товар» – моделі, аксесуари, комплектуючі та супровідні предмети;<br />
                    * «Інтернет-магазин» – відповідно до Закону України «про електронну комерцію», засіб для подання або
                    реалізації товару, роботи чи послуги шляхом здійснення електронної угоди.<br />
                    * «Продавець» – компанія, що реалізує товари, представлені на веб-сайті.<br />
                    * «Покупець» – фізична особа, уклало з Продавцем Договір на умовах, викладених нижче.<br />
                    * «Замовлення» – вибір окремих позицій із переліку товарів, зазначених Покупцем під час розміщення
                    замовлення та проведення оплати.
                </li>
            </ul>

            <Typography variant="h5" className='subtitle'>
                3. Предмет договору
            </Typography>
            <ul>
                <li>3.1. Продавець зобов’язується передати у власність Покупця Товар, а Покупець зобов’язується оплатити
                    та прийняти Товар на умовах цього Договору.<br />
                    Цей Договір регулює купівлю-продаж товарів у
                    Інтернет-магазин, у тому числі:<br />
                    – добровільний вибір Покупцем товарів у Інтернет-магазині;<br />
                    – самостійне оформлення Покупцем замовлення Інтернет-магазин;<br />
                    – оплата Покупцем замовлення, оформленого в Інтернет-магазині;<br />
                    – обробка та доставка замовлення Покупцеві у власність умовах цього Договору.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                4. Порядок оформлення замовлення
            </Typography>
            <ul>
                <li>4.1. Покупець має право оформити замовлення на будь-який товар, представлений на Сайті
                    Інтернет-магазину та наявний.
                </li>
                <li>4.2 .Кожна позиція може бути подана у замовленні в будь-якій наданій кількості.</li>
                <li>4.3. За відсутності товару на складі, Менеджер компанії зобов’язаний поставити Покупця до відома (по
                    телефону або через електронну пошту, або інстаграм – дірект).
                </li>
                <li>4.4. За відсутності товару Покупець має право замінити його товаром аналогічної моделі, відмовитися
                    від цього товару, анулювати замовлення.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                5. Порядок оплати замовлення
            </Typography>
            <ul>
                <li>5.1. Способи оплати замовлення:<br />
                    • повна оплата з комісією платіжної системи 2,2% ;<br />
                    • накладений платіж по передплаті 100 грн (у випадку відмови від посилки , передплата не
                    повертається).
                </li>
                <li>5.2. При не надходженні коштів Інтернет-магазин залишає за собою право анулювати замовлення.</li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                6. Умови доставки замовлення
            </Typography>
            <ul>
                <li>6.1. Доставка товарів, придбаних в Інтернет-магазині, здійснюється до складів транспортних компаній,
                    де і провадиться видача замовлень.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                7. Права та обов’язки сторін:
            </Typography>
            <ul>
                <li>7.1. Продавець має право:<br />
                    – в односторонньому порядку призупинити надання послуг з цього договору у разі порушення Покупцем
                    умов справжньої угоди.
                </li>
                <li> 7.2. Покупець зобов’язаний:<br />
                    – своєчасно оплатити та отримати замовлення на умовах справжнього договору.
                </li>
                <li>7.3. Покупець має право:<br />
                    – оформити замовлення в Інтернет-магазині;<br />
                    – оформити електронний договір;<br />
                    – вимагати від Продавця виконання умов цього Договору.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                8. Відповідальність сторін
            </Typography>
            <ul>
                <li>8.1. Сторони несуть відповідальність за невиконання або неналежне виконання умов цього договору у
                    порядку, передбаченому цим договором та чинним законодавством України.
                </li>
                <li>8.2. Продавець не несе відповідальності за:<br />

                    – змінений виробником зовнішній вигляд Товару;<br />

                    – за незначну невідповідність колірної гами товару, що може відрізнятись від оригіналу товару
                    виключно через різну колірної передачі моніторів персональних комп’ютерів окремих моделей;<br />

                    – за зміст та правдивість інформації, що надається Покупцем під час оформлення замовлення;<br />

                    – за затримку та перебої у наданні Послуг (обробки замовлення та доставці товару), які відбуваються
                    з причин, що перебувають поза сферою його контролю;<br />

                    – за протиправні незаконні дії, здійснені Покупцем за допомогою цього доступу до мережі
                    Інтернет;<br />

                    – за передачу Покупцем своїх мережевих ідентифікаторів – IP, MAC-адреси, логіну та паролю третім
                    особам;<br />
                </li>
                <li>8.3. Покупець, використовуючи наданий йому доступ до мережі Інтернет, самостійно відповідає за
                    шкоду, заподіяний його діями (особисто, навіть якщо під його логіном перебувала інша особа) особам
                    або їх майну, юридичним особам, державі чи моральним принципам моральності.
                </li>
                <li>8.4. У разі настання обставин непереборної сили, Сторони звільняються від виконання умов цього
                    договору. Під обставинами непереборної сили для цілей сьогодення договору розуміються події, що
                    мають надзвичайний, непередбачуваний характер, які виключають чи об’єктивно заважають виконання
                    цього договору, настання яких Сторони не могли передбачити та запобігти розумним способам.
                </li>
                <li>8.5. Сторони прикладають максимум зусиль для вирішення будь-яких розбіжностей виключно шляхом
                    переговорів.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                9. Інші умови
            </Typography>
            <ul>
                <li>9.1. Інтернет-магазин залишає за собою право в односторонньому порядку вносити зміни до цього
                    договору за умови попередньої публікації його на сайті https://shopersvi.com.ua
                </li>
                <li>9.2. Інтернет-магазин створений для організації дистанційного способу продажу товарів через
                    Інтернет
                </li>
                <li>9.3. Покупець відповідає за достовірність зазначеної під час оформлення замовлення інформації. При
                    цьому при здійсненні акцепту (оформлення замовлення та подальшої оплати товару) Покупець надає
                    Продавцю свою беззастережну згоду на збирання, обробку, зберігання, використання своїх персональних
                    даних, у розумінні ЗУ «Про захист персональних даних».
                </li>
                <li>9.4. Оплата Покупцем оформленого в Інтернет-магазині замовлення означає повну згоду Покупця з
                    умовами договору купівлі-продажу (публічної оферти)
                </li>
                <li>9.5. Фактичною датою електронної угоди між сторонами є дата прийняття умов відповідно до ст. 11
                    Закону України “Про електронну комерцію”.
                </li>
                <li>
                    9.6. Використання ресурсу Інтернет-магазину для попереднього перегляду товару, а також для
                    оформлення замовлення для покупця є безкоштовним.
                </li>
                <li>9.7. Інформація, що надається Покупцем конфіденційною. Інтернет-магазин використовує інформацію про
                    Покупці виключно з метою обробки замовлення, відправлення повідомлень Покупцю, доставки товару,
                    здійснення взаєморозрахунків та ін.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                10. Порядок повернення товару належної якості
            </Typography>
            <ul>
                <li>
                    10.1. Повернення товару в Інтернет-магазин здійснюється згідно чинного законодавства України.
                </li>
                <li>
                    10.2. Повернення товару до Інтернет-магазину здійснюється за рахунок Покупця.
                </li>
                <li>
                    10.2. Повернення товару до Інтернет-магазину здійснюється за рахунок Покупця.
                </li>
            </ul>
            <Typography variant="h5" className='subtitle'>
                11. Строк дії договору
            </Typography>
            <ul>
                <li>
                    11.1.Електронний договір вважається укладеним з моменту отримання особою, що направила пропозицію
                    укласти такий договір, відповіді про прийняття цієї пропозиції у порядку, визначеному частиною
                    шостою статті 11 Закону України “Про електронну комерції”.
                </li>
                <li>11.1.Електронний договір вважається укладеним з моменту отримання особою, що направила пропозицію
                    укласти такий договір, відповіді про прийняття цієї пропозиції у порядку, визначеному частиною
                    шостою статті 11 Закону України “Про електронну комерції”.
                </li>
                <li>11.1.Електронний договір вважається укладеним з моменту отримання особою, що направила пропозицію
                    укласти такий договір, відповіді про прийняття цієї пропозиції у порядку, визначеному частиною
                    шостою статті 11 Закону України “Про електронну комерції”.
                </li>
            </ul>
            * Звертаємо вашу увагу на те, що SHOPERS_VI, на офіційному інтернет-сайті https://shopersvi.com.ua , має
            право,
            відповідно до законодавством України, надавати право користування інтернет платформою ФОП та юридичним
            особам для реалізації товару.
            <Typography variant="h5" className='subtitle'>
                Продавець:
            </Typography>
                ФОП Івашина Вікторія Володимирівна<br/>
                IBAN: UA473220010000026007330062266<br/>
                ЄДРПОУ: 3836903282

        </Container>
    );
};

export { DogovirOfertuPage };